import React from "react";
import { observer } from "mobx-react";

import {
    Button,
    Dialog
} from "@material-ui/core";

import "../../styles/PopUp.scss";

import appStore from "../../stores/AppStore";

const styles = {
    popupstyle: {
        width: "100%",
    },
    popupTitle: {
        width: "100%"
    },
    iconStyle: {
        alignSelf: "center",
        marginRight: "10px"
    },
    panelStyle: {
        marginTop: '15px'
    }
};

const PopUp = observer(class PopUpErrorPreviRed extends React.Component {

    onClickVolver = () => {
        appStore.preguntaSeguridadStore.hideErrorSinacofi();
        if (this.props.onVolver) {
            this.props.onVolver();
        }
    };

    onClickReintentar = () => {
        appStore.preguntaSeguridadStore.hideErrorSinacofi();
        if (this.props.onReintentar) {
            this.props.onReintentar();
        }
    };
    getTexto = () => {
        return <p id="txtModal">No fue posible comprobar su identidad, por favor intentar nuevamente o dirigirse algunas de nuestras sucursales.
        </p>

    }

    render() {
        const texto = this.getTexto();
        return (
            <Dialog id="modal" modal="true" open={appStore.preguntaSeguridadStore.popupErrorSinacofi.show} style={styles.popupstyle}>
                <div className="Panel" style={styles.panelStyle}>
                    <div className="titlePopup">
                        <div id="txtTituloModal" style={styles.popupTitle}>
                        </div>
                    </div>
                    <div className="boxMensaje">
                        <div className="mensaje">
                            {texto}
                        </div>
                        <div className="boxButton">
                            <Button
                                id="btnPopUpGris"
                                variant="contained"
                                color="primary"
                                onClick={this.onClickVolver}
                                className="btn-moradoModal"
                                fullWidth={true}
                            >
                                Cancelar
                    </Button>
                            <Button
                                id="btnPopUp"
                                variant="contained"
                                color="primary"
                                onClick={this.onClickReintentar}
                                className=""
                                fullWidth={true}
                            >
                                reintentar
                    </Button>
                        </div>
                    </div>
                    <div className="franjaColores">
                        <div className="rojo" />
                        <div className="amarillo" />
                        <div className="morado" />
                    </div>
                </div>
            </Dialog>
        );
    }
});

export default PopUp;
